import { ArrowLeft } from "lucide-react";
import { Button } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/button";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/avatar";
import { useNavigate } from "react-router-dom";

const ViewProfilePhoto = () => {
  const navigate = useNavigate();
  const userProfile = JSON.parse(localStorage.getItem("userProfile") || "{}");
  const profileImage = localStorage.getItem("profileImage") || "";

  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-md space-y-4 p-4">
        {/* Header */}
        <div className="flex items-center justify-between pt-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate("/profile")}
            className="rounded-xl"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-xl font-bold text-foreground">Profile Photo</h1>
          <div className="w-10" />
        </div>

        {/* Profile Photo Display */}
        <div className="flex min-h-[70vh] items-center justify-center">
          <Avatar className="h-64 w-64 border-4 border-primary/10">
            {profileImage ? (
              <AvatarImage
                src={profileImage}
                alt="Profile"
                className="object-cover"
              />
            ) : (
              <AvatarFallback className="to-chart-1 bg-gradient-to-br from-primary text-6xl font-bold text-white">
                {userProfile.name
                  ?.split(" ")
                  .map((n: string) => n[0])
                  .join("") || "RS"}
              </AvatarFallback>
            )}
          </Avatar>
        </div>
      </div>
    </div>
  );
};

export default ViewProfilePhoto;
